import { Button, Grid, FormControlLabel, Switch } from "@mui/material";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import AppForm from "components/Shared/AppForm";
import InnerShadowBox from "components/Shared/InnerShadowBox";
import { BASE_CONSTANTS } from "constants/baseConstants";
import { useEntityDetailContext } from "contexts/EntityDetailContext";
import React from "react";
import { Controller, useForm } from "react-hook-form";

const INITIAL_STATE = {
  location: "",
  telNo: "",
  proprietorsName: "",
  additionalInfo: {
    registrationNumber: { value: "", display: true },
    panNumber: { value: "", display: true },
    vatNumber: { value: "", display: true },
    taxId: { value: "", display: true },
  },
};

export const EntityAdditionalInfoForm = ({
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
  initialValues = INITIAL_STATE,
}) => {
  const { entityDetail } = useEntityDetailContext();

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: initialValues,
  });

  React.useEffect(() => {
    if (!entityDetail) return reset(INITIAL_STATE);
    reset({
      ...initialValues,
      location: entityDetail?.location || "",
      telNo: entityDetail?.telNo || "",
      proprietorsName: entityDetail?.proprietorsName || "",
      additionalInfo: {
        registrationNumber: {
          value: entityDetail?.additionalInfo?.registrationNumber?.value || "",
          display:
            entityDetail?.additionalInfo?.registrationNumber?.display ?? true,
        },
        panNumber: {
          value: entityDetail?.additionalInfo?.panNumber?.value || "",
          display: entityDetail?.additionalInfo?.panNumber?.display ?? true,
        },
        vatNumber: {
          value: entityDetail?.additionalInfo?.vatNumber?.value || "",
          display: entityDetail?.additionalInfo?.vatNumber?.display ?? true,
        },
        taxId: {
          value: entityDetail?.additionalInfo?.taxId?.value || "",
          display: entityDetail?.additionalInfo?.taxId?.display ?? true,
        },
      },
    });
  }, [entityDetail, reset, initialValues]);

  return (
    <AppForm loading={isBusy}>
      <InnerShadowBox>
        <AppForm.Content>
          <Grid container spacing={BASE_CONSTANTS.SPACING_LG}>
            <Grid item xs={12}>
              <Controller
                name="location"
                control={control}
                rules={{
                  required: "Please provide Location.",
                }}
                render={({ field }) => (
                  <BaseTextField
                    {...field}
                    required
                    fullWidth
                    label="Location"
                    placeholder="Enter Location"
                    error={!!errors?.location}
                    helperText={errors?.location?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="telNo"
                control={control}
                rules={{
                  required: "Please provide Telephone Number.",
                }}
                render={({ field }) => (
                  <BaseTextField
                    {...field}
                    required
                    fullWidth
                    label="Telephone Number"
                    placeholder="Enter Telephone Number"
                    error={!!errors?.telNo}
                    helperText={errors?.telNo?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={8}>
                  <Controller
                    name="additionalInfo.panNumber.value"
                    control={control}
                    render={({ field }) => (
                      <BaseTextField
                        {...field}
                        fullWidth
                        label="PAN Number"
                        placeholder="Enter PAN Number"
                        error={!!errors?.additionalInfo?.panNumber?.value}
                        helperText={
                          errors?.additionalInfo?.panNumber?.value?.message
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={watch("additionalInfo.panNumber.display")}
                        onChange={(e) =>
                          setValue(
                            "additionalInfo.panNumber.display",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="Display"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={8}>
                  <Controller
                    name="additionalInfo.vatNumber.value"
                    control={control}
                    render={({ field }) => (
                      <BaseTextField
                        {...field}
                        fullWidth
                        label="VAT Number"
                        placeholder="Enter VAT Number"
                        error={!!errors?.additionalInfo?.vatNumber?.value}
                        helperText={
                          errors?.additionalInfo?.vatNumber?.value?.message
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={watch("additionalInfo.vatNumber.display")}
                        onChange={(e) =>
                          setValue(
                            "additionalInfo.vatNumber.display",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="Display"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={8}>
                  <Controller
                    name="additionalInfo.taxId.value"
                    control={control}
                    render={({ field }) => (
                      <BaseTextField
                        {...field}
                        fullWidth
                        label="Tax ID"
                        placeholder="Enter Tax ID"
                        error={!!errors?.additionalInfo?.taxId?.value}
                        helperText={
                          errors?.additionalInfo?.taxId?.value?.message
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={watch("additionalInfo.taxId.display")}
                        onChange={(e) =>
                          setValue(
                            "additionalInfo.taxId.display",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="Display"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={8}>
                  <Controller
                    name="additionalInfo.registrationNumber.value"
                    control={control}
                  
                    render={({ field }) => (
                      <BaseTextField
                        {...field}
                        label="Registration Number"
                        placeholder="Enter Registration Number"
                        error={
                          !!errors?.additionalInfo?.registrationNumber?.value
                        }
                        helperText={
                          errors?.additionalInfo?.registrationNumber?.value
                            ?.message
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={watch(
                          "additionalInfo.registrationNumber.display"
                        )}
                        onChange={(e) =>
                          setValue(
                            "additionalInfo.registrationNumber.display",
                            e.target.checked
                          )
                        }
                      />
                    }
                    label="Display"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="proprietorsName"
                control={control}
                rules={{
                  required: "Please provide Name of Proprietors.",
                }}
                render={({ field }) => (
                  <BaseTextField
                    {...field}
                    required
                    fullWidth
                    label="Name of Proprietors"
                    placeholder="Enter Name of Proprietors"
                    error={!!errors?.proprietorsName}
                    helperText={errors?.proprietorsName?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </AppForm.Content>
      </InnerShadowBox>
      <AppForm.Actions>
        <Button disabled={isBusy} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          disabled={isBusy}
          variant="contained"
          onClick={handleSubmit(onSubmit)}
        >
          Update
        </Button>
      </AppForm.Actions>
    </AppForm>
  );
};
